import React, { useMemo } from 'react';
import { FaqList } from '@/components/region/FaqList';
import { Heading } from '@/components/ui/heading';
import { IHTMLParsedData, parseHTMLtoList } from '@/util/parseHTMLtoList';
import { useSanitizedHtmlProps, SanitizeMode } from '@/util/sanitized';

// Bottom-of-page FAQ block on resort + region lift-tickets pages.
// Renders the section heading, an optional sanitized prose intro,
// and an accordion of Q&A items extracted from the SEO copy by
// parseHTMLtoList (h3 → title, body → description).

interface IProps {
  header: string,
  seoText: string,
}

export const SkipassesLiftTicketsInfo = ({ header, seoText }: IProps) => {
  const { list, text } = useMemo<IHTMLParsedData>(() => parseHTMLtoList(seoText), [seoText]);
  const htmlProps = useSanitizedHtmlProps(text || '', SanitizeMode.NormalWithImages);

  return (
    <section>
      <Heading
        level={2}
        className="mb-4"
      >
        {header}
      </Heading>
      {text && (
        <div
          {...htmlProps}
          className="mb-4 text-sm leading-relaxed text-muted-foreground"
        />
      )}
      <FaqList items={list} defaultOpenFirst />
    </section>
  );
};
